export const uploadMedia = async ({ callId, files, apiClient }) => {
    return Promise.all(files.map((file) => {
        return apiClient.request("/servicecall/uploadmedia", {
            headers: {
                CallId: callId,
                Accept: "application/json",
                "Content-Type": file.type,
                FileName: file.name
            },
            body: file,
            method: "POST",
            binary: true
        });
    }));
};
//# sourceMappingURL=uploadMedia.js.map
